// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckPlanModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckPlanModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Triple Check service response
*/
export class EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel {
    /**
    * @description Gets or sets the plan.
    */
    'plans'?: Array<EServicesOrchestratorServicePublicNewPathModelsTripleCheckPlanModel> | null;
    /**
    * @description Gets or sets the prescriber npi.
    */
    'prescriberNpi'?: string | null;
    /**
    * @description Gets or sets the transaction correlation identifier
    */
    'transactionCorrelationId'?: number;
    /**
    * @description Gets or sets the transaction identifier
    */
    'transactionDateTime'?: Moment;
    /**
    * @description Gets or sets the transaction identifier
    */
    'transactionId'?: string | null;
    /**
    * @description Gets or sets the transaction message
    */
    'transactionMessage'?: string | null;
    /**
    * @description Gets or sets the transaction message
    */
    'transactionStatus'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel>> = [
        {
            "name":     "plans",
            "baseName": "plans",
            "type":     "Array<EServicesOrchestratorServicePublicNewPathModelsTripleCheckPlanModel>"
        },
        {
            "name":     "prescriberNpi",
            "baseName": "prescriberNpi",
            "type":     "string"
        },
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "number"
        },
        {
            "name":     "transactionDateTime",
            "baseName": "transactionDateTime",
            "type":     "Date"
        },
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "string"
        },
        {
            "name":     "transactionMessage",
            "baseName": "transactionMessage",
            "type":     "string"
        },
        {
            "name":     "transactionStatus",
            "baseName": "transactionStatus",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel.attributeTypeMap;
    }
}
